<script lang="ts">
  import { getContext } from 'svelte';
  import { loginUser } from '../../../../components/auth/LoginUser';
  import RepositoryFactory, { CONTRACT } from '../../../../repositories/RepositoryFactory';
  import type {
    TMonthlySubscriptionInfoType,
    TMonthlySubscriptionInfoTypeName
  } from '../../../../constants/MonthlySubscriptionInfoType';

  const { close }: any = getContext('simple-modal');

  const errorProcess = (error: any) => {
    if (error.response.status === 403) {
      alert('セッションが切れました。再度ログインしてください');
      loginUser.logout();
      location.reload();
    } else {
      alert('エラーが発生しました。再度やり直してください。');
    }
  };

  let display: 'TOP' | 'COMPLETE' = 'TOP';
  let monthlySubscriptionInfoType: TMonthlySubscriptionInfoType;
  let changeMonthlySubscriptionInfoType: TMonthlySubscriptionInfoType;
  let changeMonthlySubscriptionInfoTypeName: TMonthlySubscriptionInfoTypeName;

  (async () => {
    const contractRepository = RepositoryFactory[CONTRACT];
    contractRepository
      .getMonthlySubscriptionInfoType()
      .then((res) => {
        monthlySubscriptionInfoType = res.monthlySubscriptionInfoType;
        settingMonthlySubscriptionInfoTypeUpdate();
      })
      .catch((error) => errorProcess(error));
  })();

  function settingMonthlySubscriptionInfoTypeUpdate() {
    switch (monthlySubscriptionInfoType) {
      case 'MAIL':
        changeMonthlySubscriptionInfoTypeName = '書面通知';
        changeMonthlySubscriptionInfoType = 'WRITING';
        break;
      case 'WRITING':
        changeMonthlySubscriptionInfoTypeName = 'メール通知';
        changeMonthlySubscriptionInfoType = 'MAIL';
        break;
    }
  }

  function handleChangeMonthlySubscriptionInfoType() {
    const contractRepository = RepositoryFactory[CONTRACT];
    contractRepository
      .changeMonthlySubscriptionInfoType({
        monthlySubscriptionInfoType: changeMonthlySubscriptionInfoType
      })
      .then((res) => {
        display = 'COMPLETE';
      })
      .catch((error) => errorProcess(error));
  }

  function handleClose() {
    if (display === 'COMPLETE') {
      location.reload();
    }
    close();
  }
</script>

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h1 class="text-2xl font-bold text-gray-700">請求額確定の通知方法変更</h1>
    </div>
  </div>

  <div class="shadow rounded bg-gray-50 border-t-4 border-green-400">
    <div class="align-middle inline-block min-w-full">
      <div class="flex">
        {#if display === 'TOP'}
          <div class="flex-1 m-5">
            <div class="inline-flex justify-items-center items-center min-w-full p-5">
              請求額確定の通知方法を{changeMonthlySubscriptionInfoTypeName}に変更しますか？
            </div>
          </div>
        {:else if display === 'COMPLETE'}
          <div class="flex-1 m-5">
            <div class="inline-flex justify-items-center items-center min-w-full p-5">
              <span>{changeMonthlySubscriptionInfoTypeName}に変更しました</span>
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>
  <div class="my-5 container flex justify-center gap-2">
    <button class="button-secondary" on:click={handleClose}> 閉じる </button>
    {#if display !== 'COMPLETE'}
      <button class="button-primary" on:click={handleChangeMonthlySubscriptionInfoType}>変更</button>
    {/if}
  </div>
</div>

<style lang="postcss">
  .button-primary {
    @apply bg-green-400 rounded-lg hover:bg-green-500 focus:outline-none text-sm font-semibold text-white px-10 py-2;
  }
  .button-secondary {
    @apply bg-gray-300 rounded-lg hover:bg-gray-400 text-gray-500 focus:outline-none text-sm font-semibold px-10 py-2;
  }
</style>
